export default function (number, currency = false) {
    return new Intl.NumberFormat('ir-IR').format(number) + (currency ? ' تومان' : '')
}
